import { render, staticRenderFns } from "./SideMenuAccessibility.html?vue&type=template&id=632cefca&scoped=true&external"
import script from "./SideMenuAccessibility.vue?vue&type=script&lang=js"
export * from "./SideMenuAccessibility.vue?vue&type=script&lang=js"
import style0 from "./SideMenuAccessibility.scss?vue&type=style&index=0&id=632cefca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632cefca",
  null
  
)

export default component.exports